// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FileUploadPresentationPropsDefault from "@insite/mobius/FileUpload/presentationProps";
import { FileUploadPresentationProps } from "@vanmeter/MobiusOverrides/FileUpload/FileUpload";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        ...FileUploadPresentationPropsDefault,
        buttonProps: {
            css: css`
                ${xScreen("lte", "xs")} {
                    margin-top: 12px;
                    margin-left: 0;
                }
            `,
        },
        uploadWrapper: {
            css: css`
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                ${xScreen("lte", "xs")} {
                    flex-direction: column;
                }
            `,
        },
        cssOverrides: {
            appearanceTransition: css`
                &,
                input,
                button {
                    &:focus-visible,
                    &:focus {
                        outline: none;
                    }
                }

                input.mobiusFileVisual {
                    &:not(:disabled):not(:focus):hover {
                        border: none;
                    }
                }
            `,
            formInputWrapper: css`
                &&&& input[class*="UploadFunctionality"] {
                    left: 0;
                    opacity: 0;
                }
            `,
        },
    } as FileUploadPresentationProps,
} as xBaseTheme["fileUpload"];
